export default function Highlighter() {
  return null
}
